import { createSelector } from 'reselect';
import { selectUser } from './user';
import { selectAppropriateUserPhone } from './userPhone';

type TUserBaseInfo = {
  email: string;
  phone: string;
  firstName: string;
  isAuthenticated: boolean;
};

export const selectUserBaseInfo = createSelector(
  [selectUser, selectAppropriateUserPhone],
  (user, phone): TUserBaseInfo => {
    if (user.isAuthenticated) {
      return {
        email: user.email || '',
        phone: phone?.phone || '',
        firstName: user.firstName || '',
        isAuthenticated: user.isAuthenticated,
      };
    }

    return {
      email: '',
      firstName: '',
      phone: phone?.phone || '',
      isAuthenticated: user.isAuthenticated,
    };
  },
);
